module.exports = __webpack_public_path__ + "static/media/blue-jays-2024-mb-en.33f12b32.jpg";